export const orderStatuses = {
  sent: 'Enviado a Conway',
  received: 'Recibido en Conway',
  preparing: 'En Preparación',
  withIncidence: 'Con Incidencia en la entrega',
  sending: 'En Proceso de Envío',
  downloading: 'Descargando',
  delivered: 'Entregado',
  rejected: 'Rechazado',
  canceled: 'Anulado'
}

export const webOrderStatusColor = {
  ok: 'darkgreen',
  ko: 'red',
  neutral: 'gray'
}

export const webOrderStatuses = {
  sent: {
    name: 'Enviado a Conway',
    icon: 'fa-paper-plane',
    color: webOrderStatusColor.ok,
    showInIndicator: true,
    showInCalendar: false,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'En proceso de envío',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  },
  received: {
    name: 'Recibido en Conway',
    icon: 'fa-clipboard-check',
    color: webOrderStatusColor.ok,
    showInIndicator: true,
    showInCalendar: false,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'En proceso de envío',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  },
  preparing: {
    name: 'En Preparación',
    icon: 'fa-cart-flatbed',
    color: webOrderStatusColor.ok,
    showInIndicator: true,
    showInCalendar: false,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En proceso de envío',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  },
  sending: {
    name: 'En proceso de envío',
    icon: 'fa-truck-fast',
    color: webOrderStatusColor.ok,
    showInIndicator: true,
    showInCalendar: true,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En proceso de envío',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  },
  downloading: {
    name: 'Descargando',
    icon: 'fa-truck-ramp-box',
    color: webOrderStatusColor.ok,
    showInIndicator: true,
    showInCalendar: true,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En proceso de envío',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  },
  withIncidence: {
    name: 'Con Incidencia en la entrega',
    icon: 'fa-truck-fast',
    color: webOrderStatusColor.ko,
    showInIndicator: true,
    showInCalendar: true,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Con incidencia en la entrega',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.ko
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.neutral
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  },
  delivered: {
    name: 'Entregado',
    icon: 'fa-solid fa-box',
    color: webOrderStatusColor.ok,
    showInIndicator: true,
    showInCalendar: true,
    allowFeedback: true,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En preparación',
        icon: 'fa-cart-flatbed',
        color: webOrderStatusColor.ok
      },
      {
        name: 'En proceso de envío',
        icon: 'fa-truck-fast',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Descargando',
        icon: 'fa-truck-ramp-box',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Entregado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.ok
      }
    ]
  },
  rejected: {
    name: 'Rechazado',
    icon: 'fa-solid fa-box',
    color: webOrderStatusColor.ko,
    showInIndicator: true,
    showInCalendar: true,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Rechazado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.ko
      }
    ]
  },
  canceled: {
    name: 'Anulado',
    icon: 'fa-solid fa-box',
    color: webOrderStatusColor.neutral,
    showInIndicator: true,
    showInCalendar: true,
    allowFeedback: false,
    graphSteps: [
      {
        name: 'Enviado a Conway',
        icon: 'fa-paper-plane',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Recibido en Conway',
        icon: 'fa-clipboard-check',
        color: webOrderStatusColor.ok
      },
      {
        name: 'Anulado',
        icon: 'fa-solid fa-box',
        color: webOrderStatusColor.neutral
      }
    ]
  }
}

export const feedbackValues = [
  { name: 'Satisfacción negativa', value: 'Worst', icon: 'fa-solid fa-frown fa-4x', color: 'red' },
  {
    name: 'Satisfacción neutral',
    value: 'Medium',
    icon: 'fa-solid fa-face-meh fa-4x',
    color: '#F9DB41'
  },
  {
    name: 'Satisfacción positiva',
    value: 'Best',
    icon: 'fa-solid fa-face-smile fa-4x',
    color: 'green'
  }
]

export const conwayTransValidValues = ['Y', 'W']
